import { render, staticRenderFns } from "./FilterBlockerPage.vue?vue&type=template&id=27919279&scoped=true"
import script from "./FilterBlockerPage.vue?vue&type=script&lang=js"
export * from "./FilterBlockerPage.vue?vue&type=script&lang=js"
import style0 from "./FilterBlockerPage.vue?vue&type=style&index=0&id=27919279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27919279",
  null
  
)

export default component.exports